import { OrderAttributes } from "@albatrosdeveloper/ave-models-package";
import { LoadCalculationModeEnum } from '@albatrosdeveloper/ave-models-package/lib/enums/load-calculation-mode.enum';

export function calculateTotalWeight(order: OrderAttributes, loadCalculationMode: string| undefined): string {
  let totalWeight = 0;

  if (!Array.isArray(order.detail)) return '0.000';

  order.detail.forEach((detailItem) => {
    if (loadCalculationMode === LoadCalculationModeEnum.BY_DIMENSIONS) {
      if (detailItem.material?.dimensions) {
        const grossWeight = detailItem.material.dimensions.grossWeight || 0;
        totalWeight += grossWeight;
      }
    } else {
      if (detailItem.material && detailItem.baseQuantity) {
        const baseQuantity = detailItem.baseQuantity || 0;
        totalWeight += baseQuantity;
      }
    }
  });

  return `${totalWeight.toFixed(3)}`;
}
